module.exports = __webpack_public_path__ + "img/other_HL.8a198a96.jpg";